module.exports = __webpack_public_path__ + "static/img/mb-14.f7ac536.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/w11/mb-14.jpg
// module id = Y4kG
// module chunks = 1